import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	header: {
		id: 'growth-ai-upsell-in-editor-free-modal.header',
		defaultMessage: 'Do your best work with AI',
		description: "Title of the modal to upsell Atlassian's AI features to customers.",
	},
	description: {
		id: 'growth-ai-upsell-in-editor-free-modal.description',
		defaultMessage: 'Start a free, 30-day <a>Premium</a> trial and let AI help you: ',
		description: "Title of the modal to upsell Atlassian's AI features to customers.",
	},
	writeCleanerDescriptions: {
		id: 'growth-ai-upsell-in-editor-free-modal.write-cleaner-descriptions',
		defaultMessage: 'Write clear descriptions for issues',
		description:
			"One of the stated benefits of using Atlassian's AI features is to improve writing.",
	},
	writeInProfessionalTone: {
		id: 'growth-ai-upsell-in-editor-free-modal.write-in-professional-tone',
		defaultMessage: 'Edit content to sound professional',
		description:
			"One of the stated benefit of using Atlassian's AI features to change the tone of the customer's writing.",
	},
	brainstorm: {
		id: 'growth-ai-upsell-in-editor-free-modal.brainstorm',
		defaultMessage: 'Brainstorm project ideas',
		description:
			"One of the stated benefit of using Atlassian's AI features to brainstorm a series of ideas.",
	},
	fixSpellingAndGrammar: {
		id: 'growth-ai-upsell-in-editor-free-modal.fix-spelling-and-grammar',
		defaultMessage: 'Catch spelling or grammar mistakes',
		description:
			"One of the stated benefit of using Atlassian's AI features to fix spelling and grammar.",
	},
	tryItFree: {
		id: 'growth-ai-upsell-in-editor-free-modal.try-it-free',
		defaultMessage: 'Try it free',
		description:
			'Label for the button that takes the user to try our AI features offered in our Jira and Confluence premium plans.',
	},
	back: {
		id: 'growth-ai-upsell-in-editor-free-modal.back',
		defaultMessage: 'Back',
		description: 'Label for the button that dismisses the AI upsell modal.',
	},
	queryError: {
		id: 'growth-ai-upsell-in-editor-free-modal.query-error',
		defaultMessage: 'There was an unknown error. Please try again later',
		description: 'An error message displayed when the query to fetch the AI upsell modal fails.',
	},
});
